export default {
  windowWidth:window.outerWidth,
  sp:320,
  sp_ex:425,
  tab:768,
  tab_ex:1024,
  pc:1200,
  pc_ex: 1440
};
